import { useCreateProductStore } from "./useCreateProductStore";

export const useProductStepInfo = () =>
  useCreateProductStore((state) => ({
    product: state.product,
    storeProduct: state.storeProduct,
    setDisabled: state.setDisabled,
  }));
